




















import Vue from "vue";

import { ecrDeviceCategoryEnumLabel, EcrDeviceCategoryEnum } from "@/model/data/ecr/EcrDeviceCategoryEnum";

export default Vue.extend({
    data() {
        return {
            loading: false,
            selectedItems: [],
        };
    },
    computed: {
        availableData() {
            var res = [];
            Object.keys(EcrDeviceCategoryEnum)
                .filter((k) => typeof EcrDeviceCategoryEnum[k as any] === "number")
                .forEach((k) => {
                    if (EcrDeviceCategoryEnum[k] >= 0) res.push({ label: this.$t(ecrDeviceCategoryEnumLabel(EcrDeviceCategoryEnum[k])), value: k });
                });
            return res;
        },
    },
    watch: {
        selectedItems() {
            this.$emit("input", this.selectedItems);
        },
    },
});
